// src/utils/apiError.js

/**
 * API 응답 객체나 Axios 에러를 사람이 읽기 쉬운 메시지로 변환합니다.
 *
 * @param {object} data - 서버에서 받은 응답(JSON)
 * @param {number} [status] - HTTP 상태 코드 (optional)
 * @returns {string} - 사용자에게 표시할 메시지
 */
export function apiErrToMessage(data, status) {
    const code = data?.code;
    const detail = data?.detail || data?.message || data?.error;

    // ✅ 서버에서 내려준 코드 우선
    switch (code) {
        case 'RATE_LIMIT_EXCEEDED':
            return detail || '오늘 조회 한도를 초과했습니다.';
        case 'UNAUTHORIZED':
            return '로그인이 필요합니다.';
        case 'BAD_REQUEST':
            return detail || '요청이 올바르지 않습니다.';
        case 'PROXY_ERROR':
            return detail || '프록시 서버 요청 중 오류가 발생했습니다.';
        case 'SERVER_ERROR':
            return '서버 오류가 발생했습니다.';
    }

    // ✅ HTTP 상태코드별 보조 처리
    if (status === 401) return '인증이 만료되었습니다. 다시 로그인해주세요.';
    if (status === 403) return '접근 권한이 없습니다.';
    if (status === 404) return '요청한 리소스를 찾을 수 없습니다.';
    if (status === 429) return detail || '오늘 사용 한도를 초과했습니다.';
    if (status === 500) return '서버 내부 오류가 발생했습니다.';

    // ✅ 기본 메시지
    return detail || '요청 처리 중 알 수 없는 오류가 발생했습니다.';
}
